import styled from 'styled-components'

const StyledTable = styled.div`

  .pagination-label {
    font-size: 11px;
    font-family: ProximaNova
  }

  .pagination-pages {
    font-size: 11px
  }

  .pagination-pages li {
    border: none;
    background: none;
  }

  .pagination-container {
    padding: 0 !important
  }

  h4 {
    text-align:center;
    font-weight: var(--font-weight-medium);
    font-size: 13px;
  }

  .page-items {
    color: var(--color-brand-600);
    font-size: 11px;
  }

  .bCYTjq {
    overflow: visible !important;
  }

  .fwZIoa  {
    padding-left: 0 !important;
  }

  .content-button > img.icon {
    width: 16px !important;
    height: 16px !important;
  }
`

export const StyledTableCell = styled.span``

export const StyledTableCellRiscosPassivos = styled.div`
  font-weight: var(--font-weight-semibold);
`

export default StyledTable